export default `
######                                         #######                                                  
#     #   ##   ##### #####  #  ####  #    #       #    #    #  ####  #    # #####   ####   ####  #    # 
#     #  #  #    #   #    # # #    # #   #        #    #    # #    # ##  ## #    # #      #    # ##   # 
######  #    #   #   #    # # #      ####         #    ###### #    # # ## # #    #  ####  #    # # #  # 
#       ######   #   #####  # #      #  #         #    #    # #    # #    # #####       # #    # #  # # 
#       #    #   #   #   #  # #    # #   #        #    #    # #    # #    # #      #    # #    # #   ## 
#       #    #   #   #    # #  ####  #    #       #    #    #  ####  #    # #       ####   ####  #    # 

================================================================
Software Engineer | Austin, TX | patrick.jthompson93@gmail.com
================================================================
Likes to work with React, Angular, and Python!
Likes to have dumb, but fun side projects
Likes to write efficient code and make robust things
LOVES to make music, and learn new things

===============
WORK EXPERIENCE (bit more serious)
===============
2019-Current: 
Software Engineer (Web), Kapsch Trafficom -- Austin, TX

- Design, develop and maintain legacy angular projects
- Optimized data collection of real time services by 23%.
- Engineered new Level of Service (LOS) dynamic fare systems (a client revenue increase of 16%!)

===============
KEYWORDS I KNOW AT LEAST A LITTLE BIT AND WOULD TOUCH AGAIN
===============
Strong:
JavaScript, Angular, ES6, Browser APIs, Figma, Responsive Design, CSS (obviously, look at this thing!), TDD, PostgreSQL

Less strong but have used and enjoy a lot:
C++(in college, with Boost), Python, C, MySQL, MongoDB, GraphQL, Gatsby.js 

Stuff I'd like to do more of:
More full stack work, build more custom components that are reusable, more GraphQL and React.

===============
LINKS
===============

Github: https://github.com/PatrickTheCodeGuy
LinkedIn: https://www.linkedin.com/in/patrick-thompson-the-code-guy/
`;
